<app-header *ngIf="showHead"></app-header>
<app-menu *ngIf="showHead"></app-menu>
<div *ngIf="showHead == true" class="content-wrapper" style="min-height: 537px;">
  <router-outlet></router-outlet>
</div>
<div *ngIf="showHead == false" style="min-height: 537px;">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="showHead"></app-footer>